<template>
    <div class="card card-body">
        <h2 v-text="__('call-to-action.more_info')"/>

        <div class="card card-body mt-3" v-for="store in stores">
            <h3 v-text="store.attributes.name"/>
            <div class="form-group m-0 pt-3" v-for="configurable in store.fields">
                <label class="font-weight-bold" v-text="configurable.label"/>
                <form ref="settings">
                    <integration-settings-input :configurable="configurable"
                                                :errors="errorsForStore(store)[configurable.field]"
                                                v-model="configsByStore[store.id][configurable.field]"
                    />
                </form>
                <span class="text-muted form-text">{{ configurable.description }}</span>
            </div>
        </div>

        <div class="d-flex flex-row mt-3">
            <div class="flex-grow-1">
                <a class="btn btn-secondary" :href="$route('integration.show', [integration.code])">
                    <i class="fas fa-reply"/>
                    {{ __('actions.abort') }}
                </a>
            </div>
            <div>
                <button class="btn btn-primary" @click="submitForm">
                    <i class="fas fa-arrow-circle-right"/>
                    {{ __('actions.next') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import IntegrationSettingsInput from '@components/Store/Includes/IntegrationSettingsInput'

export default {
    components: {
        IntegrationSettingsInput,
    },

    props: {
        stores: Array,
        integration: Object,
        errors: Object,
    },

    data() {
        return {
            form: null,
            configsByStore: {},
        }
    },

    beforeMount() {
        this.configsByStore = this.setupConfigObject()
    },

    methods: {
        submitForm() {
            this.$inertia.post(this.$route('integration.stores.link', [this.integration.code]), {
                fields: this.configsByStore,
            })
        },

        errorsForStore(store) {
            if (this.errors.hasOwnProperty(store.id)) {
                return this.errors[store.id]
            }

            return {}
        },

        setupConfigObject() {
            let configs = {}

            for (let store of this.stores) {
                configs[store.id] = {}

                for (let configurable of store.fields) {
                    let config = {
                        value: configurable.value || configurable.default,
                        field: configurable.field,
                        type: configurable.input_type,
                    }

                    if (config.type === 'period') {
                        config.unit = Object.keys(configurable.attachments.unit)[0]

                        if (configurable.attachments_value) {
                            config.unit = configurable.attachments_value.unit
                        }
                    }

                    configs[store.id][configurable.field] = config
                }
            }

            return configs
        },
    },
}
</script>
